
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class PendingOrdersGrid1 extends Serenity.EntityGrid<PendingOrdersRow, any> {
        protected getColumnsKey() { return PendingOrdersColumns.columnsKey; }
        protected getDialogType() { return PendingOrdersDialog; }
        protected getIdProperty() { return PendingOrdersRow.idProperty; }
        protected getInsertPermission() { return PendingOrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return PendingOrdersRow.localTextPrefix; }
        protected getService() { return PendingOrdersService.baseUrl; }

        

        constructor(container: JQuery) {
            super(container);
           
        }
       

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 4);

            return buttons;
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.CustomerId != null;
        }


        private _CustomerId: number;

        get CustomerId() {
            return this._CustomerId;
        }
        set CustomerId(value: number) {
            if (this._CustomerId != value) {
                this._CustomerId = value;
                this.setEquality(PendingOrdersRow.Fields.CustomerId, value);
                this.refresh();
            }
        }
    }
}